import { __assign, __extends } from "tslib";
import { PLAYBACK_EVENTS, PlaybackSingleton, } from '@wix/soundhead-playback';
import * as React from 'react';
import { defaultPlayback, defaultPlayerProps } from '../../defaultSettings';
import PlayerEngine from '../PlayerEngine';
var MasterPlayer = /** @class */ (function (_super) {
    __extends(MasterPlayer, _super);
    function MasterPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            playlist: [],
        };
        _this.playback = defaultPlayback;
        _this._onPlaylistChanged = function (playlist) {
            _this.setState({ playlist: playlist });
        };
        _this._setPlayerRef = function (instance) {
            _this.player = instance;
        };
        return _this;
    }
    MasterPlayer.prototype.componentDidMount = function () {
        this.playback = PlaybackSingleton.getInstance();
        this.playback.on(PLAYBACK_EVENTS.PLAYLIST_CHANGED, this._onPlaylistChanged);
        if (this.player) {
            this.player.injectPlayback(this.playback);
            this.player.bindAudioEvents();
        }
    };
    MasterPlayer.prototype.componentWillUnmount = function () {
        this.playback.off(PLAYBACK_EVENTS.PLAYLIST_CHANGED, this._onPlaylistChanged);
        delete this.playback;
    };
    MasterPlayer.prototype.render = function () {
        return (React.createElement(PlayerEngine, __assign({}, this.props, { ref: this._setPlayerRef, playlist: this.state.playlist })));
    };
    MasterPlayer.displayName = 'MasterPlayer';
    MasterPlayer.defaultProps = defaultPlayerProps;
    return MasterPlayer;
}(React.Component));
export default MasterPlayer;
//# sourceMappingURL=MasterPlayer.js.map